// Dashboard guide content as markdown string
export const dashboardGuideContent = `
Dashboard supports three different screen sizes:
* **Small:** Mobile devices and narrow screens
* **Medium:** Tablets and medium screens  
* **Large:** Desktop and wide screens

Each screen size has its own independent layout. 
Changing the layout of one screen size does **NOT** affect the layout of other screen sizes.
Changes are automatically saved when you exit the layout edit mode.
`;
